import * as styledComponents from "styled-components"
import { ThemedStyledComponentsModule } from "styled-components"

interface ThemeInterface {
  BASE_SIZE: number
  UNIT: string
  colors: {
    blue: string
    green: string
    yellow: string
    teal: string
    lightBlue: string
    red: string
    orange: string
    white: string
    black: string
    grey: string
    darkGrey: string
    lightGrey: string
    primary: string
    secondary: string
    success: string
    error: string
    info: string
  }
}

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider
} = styledComponents as ThemedStyledComponentsModule<ThemeInterface>

export { css, createGlobalStyle, keyframes, ThemeProvider }
export default styled
